
import { useStore } from "vuex";
import { defineComponent } from "vue";
import CraftPanel from "@/components/shared/CharStats/CraftPanel.vue";
import GenericPanel from "../GenericPanel.vue";
import GenericButton from "../GenericButton.vue";

export default defineComponent({
  components: {
    CraftPanel,
    GenericPanel,
    GenericButton
},
  name: "CraftMenu",
  setup() {
    const store = useStore();

    const closePanel = () => {
      store.dispatch('showDefaultCharStats')
    }
    const getTitle = () => {
      return store.state.craftedItem.slot === 'body' ? 'CRAFT ARMOR' : store.state.craftedItem.slot === 'head' ? 'CRAFT HELMET' : 'CRAFT WEAPON';
    }
    return {
      state: store.state,
      closePanel,
      getTitle
    };
  },
});

